export const customSubstring = (value, length) => {
  return value.length > length ? value.substring(0, length) : value;
};
